import React from "react";
import { createRoot } from "react-dom/client";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import EmsFeeReceiptDocument from "./EmsFeeReceiptDocument";

export async function downloadEmsFeeReceiptPdf(receiptData, filename = "fee-receipt.pdf") {
  if (!receiptData) return;

  const host = document.createElement("div");
  host.style.position = "fixed";
  host.style.left = "-10000px";
  host.style.top = "0";
  host.style.width = "210mm";
  host.style.background = "#fff";
  document.body.appendChild(host);

  const root = createRoot(host);

  try {
    root.render(<EmsFeeReceiptDocument data={receiptData} />);
    await new Promise((resolve) => setTimeout(resolve, 300));

    const element = host.querySelector("#ems-fee-receipt-document");
    if (!element) return;

    const images = Array.from(element.querySelectorAll("img"));
    await Promise.all(
      images.map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) {
              resolve();
              return;
            }
            img.onload = () => resolve();
            img.onerror = () => resolve();
          })
      )
    );

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
      width: element.scrollWidth,
      height: element.scrollHeight,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    const scale = imgHeight > pageHeight ? pageHeight / imgHeight : 1;
    const finalWidth = imgWidth * scale;
    const finalHeight = imgHeight * scale;
    const xOffset = (pageWidth - finalWidth) / 2;

    pdf.addImage(imgData, "PNG", xOffset, 0, finalWidth, finalHeight);
    pdf.save(filename);
  } finally {
    root.unmount();
    host.remove();
  }
}
